import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Users, Clock } from "lucide-react";
import "../lms.css";

export default function StudentsLayout() {
  return (
    <div style={{ padding: "8px 16px 16px", maxWidth: "1400px", margin: "0 auto" }}>
      {/* Compact Sub-Navigation Tabs Bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          borderBottom: "1.5px solid #e2e8f0",
          marginBottom: "10px",
          gap: "6px",
        }}
      >
        {/* Tab 1: Students Directory */}
        <NavLink
          to="/lms/students"
          end
          style={({ isActive }) => ({
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 14px",
            fontWeight: "600",
            fontSize: "13px",
            textDecoration: "none",
            borderBottom: isActive ? "2.5px solid #1c498d" : "2.5px solid transparent",
            color: isActive ? "#1c498d" : "#64748b",
            background: isActive ? "#eff6ff" : "transparent",
            borderRadius: "6px 6px 0 0",
            marginBottom: "-1.5px",
            transition: "all 0.15s ease",
          })}
        >
          <Users size={15} />
          <span>Students Directory</span>
        </NavLink>

        {/* Tab 2: Student Requests */}
        <NavLink
          to="/lms/students/requests"
          style={({ isActive }) => ({
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 14px",
            fontWeight: "600",
            fontSize: "13px",
            textDecoration: "none",
            borderBottom: isActive ? "2.5px solid #1c498d" : "2.5px solid transparent",
            color: isActive ? "#1c498d" : "#64748b",
            background: isActive ? "#eff6ff" : "transparent",
            borderRadius: "6px 6px 0 0",
            marginBottom: "-1.5px",
            transition: "all 0.15s ease",
          })}
        >
          <Clock size={15} />
          <span>Student Requests</span>
        </NavLink>
      </div>

      {/* Routed Child Component */}
      <Outlet />
    </div>
  );
}
